const PENDING_SMS_LOGIN_KEY = "pf_sms_login";

/** Survives a reload of the tab (forced update, tab discard, switching to the SMS app). */
export type PendingSmsLogin = {
  mode: "sms" | "testCode";
  /** E.164 */
  phoneNumber: string;
  practiceId: string;
  verificationId?: string;
  sentAt: number;
  resendCount: number;
};

/** Carries the flow from the phone screen to the code screen when sessionStorage is blocked. */
let pendingInMemory: PendingSmsLogin | undefined;

export const readPendingSmsLogin = (): PendingSmsLogin | undefined => {
  try {
    const raw = sessionStorage.getItem(PENDING_SMS_LOGIN_KEY);
    if (raw) return JSON.parse(raw) as PendingSmsLogin;
  } catch {
    // the memory copy below
  }
  return pendingInMemory;
};

export const writePendingSmsLogin = (pending: PendingSmsLogin) => {
  pendingInMemory = pending;
  try {
    sessionStorage.setItem(PENDING_SMS_LOGIN_KEY, JSON.stringify(pending));
  } catch {
    // Storage blocked: the memory copy carries the flow until the tab reloads.
  }
};

export const clearPendingSmsLogin = () => {
  pendingInMemory = undefined;
  try {
    sessionStorage.removeItem(PENDING_SMS_LOGIN_KEY);
  } catch {
    // nothing to clear
  }
};

export const hasPendingSmsLogin = () => readPendingSmsLogin() !== undefined;
